module.exports = __webpack_public_path__ + "img/myqr-logo-napas247@3x.bb3c376d.png";